const fieldValidation = {
  required: '{{fieldName}} 是必须的',
  pattern: '{{fieldName}} is invalid',
};

export default fieldValidation;
